
import { ASSET_METADATA } from '../../asset/model/asset.metadata';
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { COST_CENTRE_METADATA } from '../../costcentre/model/cost-centre.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class TransferAssetMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('TransferAsset', {
      transferAssetId: <PropertyMetadata> {
        name: 'transferAssetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      asset: <PropertyMetadata> {
        name: 'asset',
        type: 'Asset',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSET_METADATA;
        },
        byReference: true,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      costCentre: <PropertyMetadata> {
        name: 'costCentre',
        type: 'CostCentre',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return COST_CENTRE_METADATA;
        },
        byReference: true,
        unique: false
      },
      approvalRejectionComment: <PropertyMetadata> {
        name: 'approvalRejectionComment',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      approved: <PropertyMetadata> {
        name: 'approved',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      approvedRejectedBy: <PropertyMetadata> {
        name: 'approvedRejectedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      approvedRejectedDate: <PropertyMetadata> {
        name: 'approvedRejectedDate',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 7,
        unique: false
      },
      assetSrcBusinessUnit: <PropertyMetadata> {
        name: 'assetSrcBusinessUnit',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      assetSrcCostCentre: <PropertyMetadata> {
        name: 'assetSrcCostCentre',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      dateCreated: <PropertyMetadata> {
        name: 'dateCreated',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 7,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.transferAssetId;
    return nullIfContainsNull(result);
  }
}



